export const zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  popper: 1075,
  drawer: 1075,
  appBar: 1100,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500,
  select: 1300,
};
